import {
  SubscriptionEntityTypeEnum,
  SubscriptionStateEnum
} from '../types/subscription';

export const getActivePaperSubscription = (entities: any[]) => {
  const instantPaper = entities.filter(
    (item) =>
      item.entityType === SubscriptionEntityTypeEnum.PAPER &&
      item.state !== SubscriptionStateEnum.CANCELED &&
      item.state !== SubscriptionStateEnum.CANCELING
  );

  return instantPaper.length > 0;
};
